export default "__VITE_ASSET__nNqq2jD9__"